"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
exports.DummyProvider = function (_a) {
    var id = _a.id, component = _a.component, children = _a.children;
    if (process.env.NODE_ENV === 'development') {
        console.warn("FormJS: " + id + " cannot be rendered because component " + component + " is unknown to FormJS.");
        return (React.createElement("div", null,
            React.createElement("div", { style: {
                    background: 'rgba(251, 245, 180, 0.3)',
                    fontFamily: 'monospace',
                    color: '#9F6000',
                    padding: '8px',
                } },
                "FormJS: ",
                React.createElement("strong", null, id),
                " cannot be rendered because component",
                ' ',
                React.createElement("strong", null, component),
                " is unknown to FormJS."),
            React.createElement("div", null, children)));
    }
    return React.createElement("div", null);
};
exports.mapState = function (state, props) {
    var id = props.id;
    return {
        component: state.component[id],
    };
};
exports.default = react_redux_1.connect(exports.mapState)(exports.DummyProvider);
//# sourceMappingURL=DummyProvider.js.map